/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Point, Size } from "src/classes/plate/lib/types";
import { ArrowSession, DragBlockSession, DragCanvasSession, ResizeSession } from "src/classes/plate/Session";

/* -------------------------------------------------- */
/*                Main Session Types                  */
/* -------------------------------------------------- */

export type Session = DragBlockSession | ArrowSession | ResizeSession | DragCanvasSession;

export type SessionSnapshot =
  | DragCanvasSessionSnapshot
  | ArrowSessionSnapshot
  | DragBlockSessionSnapshot
  | ResizeSessionSnapshot;

export enum SessionType {
  Arrow,
  DragCanvas,
  DragBlock,
  Resize,
}

/* -------------------------------------------------- */
/*                  Session Instances                 */
/* -------------------------------------------------- */

export enum DragMode {
  Multiselect,
  Create,
}
export type DragCanvasSessionSnapshot = {
  type: SessionType.DragCanvas;
  anchor: Point;
  focus: Point;
  mode: DragMode;
  dimensions: Size;
};

export type ArrowSessionSnapshot = {
  type: SessionType.Arrow;
};

export type DragBlockSessionSnapshot = {
  type: SessionType.DragBlock;
  anchor: Point;
  hasDuplicated: boolean;
};

export type ResizeSessionSnapshot = {
  type: SessionType.Resize;
  anchor: Point;
};
